export const licensePlateInputSsKey = 'licensePlate'
export const paymentStepSessionStorageKey = 'paymentStep'
export const userEmailSessionStorageKey = 'userEmail'
